// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import translate from "@insite/client-framework/Translate";
import {
    GetCategoriesApiParameter,
    getShopbyCategories,
    ShopByCategoryModel,
} from "@werner/App/Services/ShopByCategoryService";
import { ErrorApiDefaultMessage } from "@werner/XDL/constants";

type HandlerType = ApiHandler<HasOnSuccess & HasOnError<string> & GetCategoriesApiParameter, ShopByCategoryModel>;

export const DispatchBeginLoadShopbyCategories: HandlerType = props => {
    props.dispatch({
        type: "xShopByCategory/BeginLoadShopbyCategories" as any,
        key: getDataViewKey(props.parameter),
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getShopbyCategories(props.apiParameter);
    } catch (error) {
        const failedMessage = translate(ErrorApiDefaultMessage);
        props.parameter.onError?.(failedMessage);
        props.dispatch({
            type: "xShopByCategory/FailedToLoadShopbyCategories",
            failedMessage,
            key: getDataViewKey(props.apiParameter),
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadShopbyCategories: HandlerType = props => {
    props.dispatch({
        type: "xShopByCategory/CompleteLoadShopbyCategories",
        data: props.apiResult,
        key: getDataViewKey(props.apiParameter),
    } as any);
};

export const chain = [
    DispatchBeginLoadShopbyCategories,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadShopbyCategories,
];

const loadShopbyCategories = createHandlerChainRunner(chain, "loadShopbyCategoriesHandler");
export default loadShopbyCategories;
